import { useTranslations } from "@frontend/lib/next-intl-typed";

export const PriceToggleSymbol = ({
  checked = false,
  isProductSelfPayOnly = false,
}: { checked?: boolean; isProductSelfPayOnly?: boolean }) => {
  const t = useTranslations("InsuranceConnector");
  if (!checked && !isProductSelfPayOnly) return null;
  return (
    <img
      src="/icons/insurance-toggle.svg"
      alt={t("PriceToggleSymbolAlt")}
      className="absolute inset-0 w-full h-full"
    />
  );
};
